export default __webpack_public_path__ + "static/media/ic-tel.e4de4da0.svg";